import { createFileRoute } from '@tanstack/react-router'
import { APP_NAME } from '@/lib/utils'
import Affectation from '@/features/affectation'

export const Route = createFileRoute('/_authenticated/affectation/')({
  component: Affectation,
  head: () => ({
    meta: [
      {
        title: `${APP_NAME} | Affectations`,
      },
    ],
  }),
})
